// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__HTnbZ","headshot":"Card_headshot__HmKVr"};